import type { ReactNode } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from '@/shared/auth/AuthProvider'
import { AppThemeProvider } from './theme/AppThemeProvider'
import { queryClient } from './queryClient'

/**
 * Providerlar tartibi TASODIFIY EMAS (xsib-admin naqshi):
 *
 *   Query → Theme → Router → Auth
 *
 * · `AuthProvider` `useQuery` ishlatadi, ya'ni `QueryClientProvider` ichida
 *   bo'lishi shart
 * · `AppThemeProvider` antd `App` ni beradi — xabar undan pastdagi hamma
 *   joyda ishlashi kerak
 * · `AuthProvider` router ICHIDA: chiqishda marshrutga ta'sir qiladi
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AppThemeProvider>
        <BrowserRouter>
          <AuthProvider>{children}</AuthProvider>
        </BrowserRouter>
      </AppThemeProvider>
    </QueryClientProvider>
  )
}
